import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ChannelsWeHandle } from './components/ChannelsWeHandle';
import { CoreOffering } from './components/CoreOffering';
import { AdoptAI } from './components/AdoptAI';
import { LeadManagement } from './components/LeadManagement';
import { Vision } from './components/Vision';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Create script element for chat widget
    const script = document.createElement('script');
    script.src = 'https://bot.messagesimproved.com/chat-widget.js?bot=8198cf73-90f0-44cd-b57e-0fc5d63bb414';
    script.async = true;
    // Append to the document body
    document.body.appendChild(script);
    // Cleanup function to remove the script when component unmounts
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []); // Empty dependency array ensures this runs once on mount
  return <div className="bg-black text-white min-h-screen font-sans" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ChannelsWeHandle data-id="element-4" />
        <CoreOffering data-id="element-5" />
        <AdoptAI data-id="element-6" />
        <LeadManagement data-id="element-7" />
        <Vision data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}